const BRIEF_SIGNALS: Record<string, RegExp[]> = {
  objetivo: [/objetivo/i, /aprender/i, /lograr/i, /desarrollar/i, /comprender/i, /analizar/i],
  contenido: [/contenido/i, /habilidad/i, /tema/i, /concepto/i, /oa\b/i, /eje/i],
  metodologia: [/metodolog/i, /enfoque/i, /secuencia/i, /estrategia/i, /progresiv/i],
  contexto: [/contexto/i, /nivel/i, /curso/i, /aula/i, /estudiante/i],
  producto: [/producto/i, /evidencia/i, /demostr/i, /evaluaci/i, /cierre/i],
};

const LABELS: Record<string, string> = {
  objetivo: 'Objetivo',
  contenido: 'Contenido',
  metodologia: 'Metodología',
  contexto: 'Contexto',
  producto: 'Producto',
};

function normalizeText(value = ''): string {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

function clamp(value: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, value));
}

export interface BriefCompletenessAnalysis {
  textoOriginal: string;
  textoNormalizado: string;
  completitud: number;
  elementosDetectados: string[];
  esValido: boolean;
}

export function analyzeBriefCompleteness(briefText = ''): BriefCompletenessAnalysis {
  const textoOriginal = String(briefText || '');
  const textoNormalizado = normalizeText(textoOriginal);
  const elementosDetectados = Object.entries(BRIEF_SIGNALS)
    .filter(([, patterns]) => patterns.some((pattern) => pattern.test(textoNormalizado)))
    .map(([key]) => key);

  const longitudScore =
    textoNormalizado.length >= 280
      ? 100
      : textoNormalizado.length >= 180
        ? 80
        : textoNormalizado.length >= 100
          ? 60
          : textoNormalizado.length >= 50
            ? 40
            : textoNormalizado.length > 0
              ? 20
              : 0;

  const completitud = clamp(
    Math.round((elementosDetectados.length / 5) * 75 + longitudScore * 0.25),
    0,
    100,
  );

  const esValido =
    textoNormalizado.length >= 120 ||
    (textoNormalizado.length >= 40 && elementosDetectados.length >= 2);

  return {
    textoOriginal,
    textoNormalizado,
    completitud,
    elementosDetectados,
    esValido,
  };
}

export function briefElementLabels(): Record<string, string> {
  return LABELS;
}

export function isBriefReadyForGeneration(analysis: BriefCompletenessAnalysis): boolean {
  return analysis.esValido && analysis.completitud >= 60;
}
